import { THEME_COLOR, THEME_STORAGE_KEY } from './theme'

/**
 * Theme boot — runs before first paint (injected via sede.extraHead, before
 * any stylesheet). Adds `js` to <html> (gates the [data-reveal] hidden state
 * so no-JS readers and crawlers see everything), `reveal-timeout` 4 s later
 * (the failsafe that shows those targets if the bundle died) and sets the
 * `dark` class Tailwind's darkMode:'class' reads from the visitor's saved
 * choice (localStorage `vv2-theme`, written by the header's ThemeToggle).
 * With no saved choice — or storage that throws — the site is light, whatever
 * the device's colour scheme.
 *
 * On a saved dark choice it also repaints the theme-color meta to the dark
 * canvas, so the browser chrome matches from the first frame. That needs the
 * meta already parsed: the sede's extraHead emits THEME_HEAD_TAGS BEFORE this
 * script (src/sedi/verde-valsesia-2.ts).
 *
 * Pure string: importable from Node (vite.config.ts / prerender); it takes
 * only constants from theme.ts.
 */
const js = [
  '(function(){',
  'var d=document.documentElement;',
  "d.classList.add('js');",
  `var t=null;try{t=localStorage.getItem('${THEME_STORAGE_KEY}')}catch(e){}`,
  "d.classList.toggle('dark',t==='dark');",
  // Unquoted attribute selector (same match): the literal name="theme-color"
  // then appears only in the meta tag itself — seo-render.ts's guard keys on it.
  `if(t==='dark'){var m=document.querySelector('meta[name=theme-color]');if(m){m.setAttribute('content','${THEME_COLOR.dark}')}}`,
  // Failsafe for the hidden reveal state: if the bundle never runs, vv2.css
  // shows the [data-reveal] / [data-hero-reveal] targets after 4 s.
  "setTimeout(function(){d.classList.add('reveal-timeout')},4000);",
  '})();',
].join('')

export const THEME_BOOT_SCRIPT = `<script>${js}</script>`

/**
 * Light page chrome by default; html.dark switches color-scheme in vv2.css,
 * and the boot script / ThemeToggle rewrite the theme-color. Must come before
 * THEME_BOOT_SCRIPT in the head, so the script finds the theme-color meta.
 */
export const THEME_HEAD_TAGS: readonly string[] = [
  '<meta name="color-scheme" content="light" />',
  `<meta name="theme-color" content="${THEME_COLOR.light}" />`,
]
